import {Map, List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Contact from './model';

export const fetchChildContacts = childId => {
    return RESTClient.getAuthenticatedObservable('v2/relations', {
        childId,
    }).map(relations => Map(relations.map(relation => [relation.relationId, Contact.fromAPI(relation)])));
};

export const fetchChildContact = relationId => {
    return RESTClient.getAuthenticatedObservable(`v2/relations/${relationId}`);
};

export const updateContactData = (data, shouldUpdateSSN = true, shouldUpdateAddress = true, ssnToken = null) => {
    const {
        relationId,
        salutation,
        firstName,
        middleName,
        lastName,
        relationSsn,
        street,
        zip,
        city,
        protectedAddress,
        phone,
        workPhone,
        homePhone,
        placeOfWork,
        occupation,
        hideFromPhoneList,
        relationTitle,
        email,
        extraInfo,
        country,
        state,
        emergencyContact,
    } = data;

    const content = {
        salutation,
        firstName,
        middleName,
        lastName,
        phone,
        workPhone,
        homePhone,
        placeOfWork,
        occupation,
        hideFromPhoneList,
        status: relationTitle,
        email,
        extraInfo,
        emergencyContact,
    };

    if (shouldUpdateSSN) {
        content.ssn = relationSsn;

        if (ssnToken) {
            content.token = ssnToken.token;
            content.expires = ssnToken.expires;
        }
    }

    if (shouldUpdateAddress) {
        content.protectedAddress = protectedAddress;
        content.street = street;
        content.zip = zip;
        content.city = city;
        content.country = country;
        content.state = state;
    }

    return RESTClient.postAuthenticatedObservable(`v2/relations/${relationId}`, content).map(Contact.fromAPI);
};

export const fetchKikuRelations = childId =>
    RESTClient.getAuthenticatedObservable(`v2/kiku-relation/${childId}`).map(({kikuRelations}) =>
        List(kikuRelations).map(rel => ({
            relationId: rel.relationId,
            kikuRelation: Contact.kikuRelationFromApi(rel),
        })),
    );

export const updateKikuRelation = (relationId, kikuRelation) =>
    RESTClient.postAuthenticatedObservable(`v2/kiku-relation/${relationId}`, {
        kikuRelation: {
            maritalStatus: kikuRelation.maritalStatus,
            employeeId: kikuRelation.employeeId,
        },
    }).map(({kikuRelation}) => Contact.kikuRelationFromApi(kikuRelation));

export const deactivate = relationId => {
    return RESTClient.postAuthenticatedObservable('daycare/relation/deactivate', {
        relationId,
    });
};

export const fetchSSN = (relationId, password) => {
    return RESTClient.postAuthenticatedObservable(`v2/relations/${relationId}/ssn`, {password});
};

export const fetchProtectedAddress = relationId => {
    return RESTClient.getAuthenticatedObservable(`v2/relations/${relationId}/protected-address`);
};

export const updateChildContactEmail = (relationId, email) => {
    return RESTClient.postAuthenticatedObservable(`v2/relations/${relationId}`, {
        email,
    });
};

export const fetchEmployeeRelations = employeeId => {
    return RESTClient.getAuthenticatedObservable('v2/employeerelations', {
        employeeId,
    }).map(relations => Map(relations.map(relation => [relation.relationId, Contact.fromAPI(relation)])));
};

export const createEmployeeRelation = (employeeId, name, status = '', phone = '') => {
    return RESTClient.postAuthenticatedObservable('v2/employeerelations', {
        employeeId,
        name,
        status,
        email: '',
        phone,
        workPhone: '',
        homePhone: '',
    }).map(relation => Contact.fromAPI(relation));
};

export const updateEmployeeRelation = ({
    relationId,
    firstName,
    middleName,
    lastName,
    relationTitle,
    email,
    phone,
    workPhone,
    homePhone,
}) => {
    return RESTClient.postAuthenticatedObservable(`v2/employeerelations/${relationId}`, {
        firstName,
        middleName,
        lastName,
        status: relationTitle,
        email,
        phone,
        workPhone,
        homePhone,
    }).map(Contact.fromAPI);
};

export const deactivateEmployeeRelation = relationId => {
    return RESTClient.postAuthenticatedObservable(`v2/employeerelations/${relationId}`, {
        delete: 1,
    });
};
